import { html, nothing } from 'lit';
import componentStyles from './cta-image.css.lit.ts';
import { OutlineElement } from '../../base/outline-element/outline-element.ts';
import { classMap } from "lit-html/directives/class-map";

/**
 * Call to Action image card. Regular and Homepage variant.
 *
 * @element hf-cta-image
 */
export default class CtaImage extends OutlineElement {
  static styles = [super.styles, componentStyles];
  static get properties() {
    return {
      /**
       * Main content area title
       */
      title: { type: String },
      /**
       * Main content area eyebrow above title
       */
      eyebrow: { type: String },
      /**
       * Main content area text below title
       */
      text: { type: String },
      /**
       * Button text
       */
      ctaText: { type: String },
      /**
       * Button url
       */
      ctaUrl: { type: String },
      /**
       * Button target
       */
      ctaTarget: { type: String },
      /**
       * Button GTM
       */
      ctaGTM: { type: String },
      /**
       * Button id
       */
      id: { type: String },
    };
  }

  render() {
    let title = html`<hf-heading
              level="1"
              levelstyle="cta-image"
              class="${this.eyebrow
        ? 'cta-image__title'
        : 'cta-image__title cta-image__title--no-eyebrow'}">
              ${this.title}
            </hf-heading>`;

    if (this.id === 'big-hero') {
      title = html`<h1 class=" heading style--cta-image ">
              ${this.title}
            </h1>`;
    }

    return html`
      <div
        class="${classMap({
      'cta-image': true,
    })}"
      >
        <div class="cta-image__wrapper">
          <div class="cta-image__image">
            <hf-responsive-image
              imageStyle="cta-image"
            >
              <div slot="image">
                <slot name="image"></slot>
              </div>
            </hf-responsive-image>
          </div>
          <div class="${this.eyebrow
        ? 'cta-image__content'
        : 'cta-image__content cta-image__content--no-eyebrow'}">
            ${this.eyebrow ? html`<hf-heading
              level=""
              levelStyle="eyebrow"
              class="cta-image__eyebrow"
            >
              ${this.eyebrow}
            </hf-heading>` : nothing}
            ${title}
            <hf-paragraph
              styleclass="cta-image"
              class="${this.eyebrow
        ? 'cta-image__text'
        : 'cta-image__text cta-image__text--no-eyebrow'}">
              <hf-wysiwyg markup="${this.text}"></hf-wysiwyg>
            </hf-paragraph>
              ${(this.ctaUrl &&
        this.ctaText &&
        html`
                  <div class="${this.eyebrow
            ? 'cta-image__button'
            : 'cta-image__button cta-image__button--no-eyebrow'}">
                    <hf-button type="primary" class="${this.ctaClass}" href="${this.ctaUrl}" target="${this.ctaTarget}" gtm="${this.ctaGTM}" ignoreExternalUrl>
                      ${this.ctaText}
                    </hf-button>
                  </div>
                `) ||
      ''}
          </div>
        </div>
      </div>
    `;
  }
}

customElements.define('hf-cta-image', CtaImage);
